/** "08/2026" a partir do par mês/ano. */
export function competenciaLabel(d: { month: number; year: number }): string {
  return `${String(d.month).padStart(2, '0')}/${d.year}`;
}

/** Mês/ano de uma data ISO, em UTC — as colunas são DATE, sem hora. */
export function competenciaDe(iso: string): { month: number; year: number } {
  const d = new Date(iso);
  return { month: d.getUTCMonth() + 1, year: d.getUTCFullYear() };
}

/** true quando competência e fato caem em meses diferentes. */
export function competenciaDeslocada(t: {
  transactionDate: string;
  competenceDate: string;
}): boolean {
  const a = competenciaDe(t.transactionDate);
  const b = competenciaDe(t.competenceDate);
  return a.month !== b.month || a.year !== b.year;
}
